
{
  "labels": {
    "headline": "Heading",
    "subheading": "Paragraph"
  }
}
